var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import '../styles/DialogStyles.css';
import '../styles/PageStyles.css';
import { ConsoleLogger as Logger, Hub, I18n } from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import { AuthPiece } from "aws-amplify-react";
import { NavItem } from "reactstrap";
import { UsernameAttributes } from "aws-amplify-react/lib/Auth/common/types";
import { STATE_SIGN_IN } from "./AuthComponent";
import { getCurrentUser } from "./GetCurrentUser";
export var defaultLandingPage = '/';
var logger = new Logger('Authentication');
var Authentication = /** @class */ (function (_super) {
    __extends(Authentication, _super);
    function Authentication(props) {
        var _this = _super.call(this, props) || this;
        _this.signOut = function () {
            _this.setState({ toLandingPage: true });
            Auth.signOut()
                .then(function (data) { return console.log(data); })
                .catch(function (err) { return console.log(err); });
        };
        _this.state = {
            toLandingPage: false
        };
        _this.loggedIn = _this.loggedIn.bind(_this);
        _this.onHubCapsule = _this.onHubCapsule.bind(_this);
        Hub.listen('auth', _this.onHubCapsule);
        _this._validAuthStates = ['signedIn'];
        _this._isMounted = false;
        return _this;
    }
    Authentication.prototype.componentDidMount = function () {
        this._isMounted = true;
        this.findState();
    };
    Authentication.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    Authentication.prototype.findState = function () {
        var _this = this;
        if (!this.props.authState && !this.props.authData) {
            Auth.currentAuthenticatedUser()
                .then(function (user) {
                _this.setState({
                    authState: 'signedIn',
                    authData: user,
                    stateFromStorage: true,
                });
            })
                .catch(function (err) { return logger.debug(err); });
        }
    };
    Authentication.prototype.onHubCapsule = function (capsule) {
        var _this = this;
        if (this._isMounted) {
            var channel = capsule.channel, payload_1 = capsule.payload;
            if (channel === 'auth' && payload_1.event === 'signIn') {
                getCurrentUser().then(function (user) {
                    if (_this.props.adminsOnly && !user.isAdmin) {
                        _this.signOut();
                        var onStateChange = _this.props.onStateChange;
                        if (onStateChange !== undefined) {
                            onStateChange(STATE_SIGN_IN, { signInError: "Admin2Gether steht nur für Admins zur Verfügung." });
                        }
                    }
                    else {
                        _this.setState({
                            authState: 'signedIn',
                            authData: payload_1.data,
                        });
                        if (!_this.props.authState) {
                            _this.setState({ stateFromStorage: true });
                        }
                    }
                });
            }
            else if (channel === 'auth' && payload_1.event === 'signOut' && !this.props.authState) {
                this.setState({
                    authState: 'signIn'
                });
            }
        }
    };
    Authentication.prototype.loggedIn = function (name) {
        var _a = this.props.usernameAttributes, usernameAttributes = _a === void 0 ? UsernameAttributes.USERNAME : _a;
        var prefix = usernameAttributes === UsernameAttributes.USERNAME
            ? I18n.get('Hello') + " "
            : '';
        return "" + prefix + name;
    };
    Authentication.prototype.outAuth = function () {
        return '';
    };
    Authentication.prototype.userAuthentication = function (theme) {
        var user = this.props.authData || this.state.authData;
        var loggedIn = this.props.loggedIn || this.loggedIn;
        // get name from attributes first
        var _a = this.props.usernameAttributes, usernameAttributes = _a === void 0 ? 'username' : _a;
        var name;
        switch (usernameAttributes) {
            case UsernameAttributes.EMAIL:
                // Email as Username
                name = user.attributes ? user.attributes.email : user.username;
                break;
            case UsernameAttributes.PHONE_NUMBER:
                // Phone number as Username
                name = user.attributes ? user.attributes.phone_number : user.username;
                break;
            default:
                var nameFromAttr = user.attributes
                    ? user.attributes.name ||
                        (user.attributes.given_name
                            ? user.attributes.given_name + ' ' + user.attributes.family_name
                            : undefined)
                    : undefined;
                name = nameFromAttr || user.name || user.username;
                break;
        }
        var message = typeof loggedIn === 'function' ? loggedIn(name) : loggedIn;
        return (React.createElement("span", null,
            React.createElement(NavItem, { theme: theme }, message)));
    };
    Authentication.prototype.noUserAuth = function (theme) {
        var loggedOut = this.props.loggedOut || this.outAuth;
        var message = typeof loggedOut === 'function' ? loggedOut() : loggedOut;
        return message ? React.createElement(NavItem, { theme: theme }, message) : null;
    };
    Authentication.prototype.render = function () {
        return React.createElement("div", { id: "signedIn" });
    };
    return Authentication;
}(AuthPiece));
export default Authentication;
//# sourceMappingURL=Authentication.js.map